<div>
  <p-scrollPanel [style]="{ width: '100%', height: '69vh' }">
  @for (legendElement of this.pawService.legendEntries; track legendElement; let i = $index) {
    <div class="flex w-[30vw] pt-[1vh]">
      <div class="flex w-[3vw] justify-center items-center">
        <div class="w-[2vw] h-[1vh]" [style]="{background:legendElement.x}"></div>
      </div>
      <div class="w-[27vw]">
        <input [id]="'text'+legendElement.x" type="text" variant="filled" fluid="true" pInputText pSize="large"
          [(ngModel)]="pawService.legendEntries[i].y"/>
        </div>
      </div>
    }
  </p-scrollPanel>
  </div>
